



function noop() {

}

let _getPreference = noop;
let _setPreference = noop;

export function registerPreferenceCallbacks(pars) {
	_getPreference = pars.getPreference || noop;
	_setPreference = pars.setPreference || noop;
}

export function getPreference(key) {
	return _getPreference(key);
}

export function setPreference(key, value) {
	_setPreference(key, value);
}

export function getComponentPreferenceKey(componentName, path, key) {
	return componentName + '//' + (Array.isArray(path) ? path.join('/') : path) + '//' + key;
}
